// Kilo hedefi ilerlemesi: başlangıç → güncel → hedef, ince ilerleme çubuğu ve
// son 4 haftanın haftalık ortalama değişimi. Güncel kilo tartı/elle girilen
// "weight" ölçümlerinden gelir (series: [{ takenAt, weight }], yeniden eskiye).

import React from "react";
import { Box, LinearProgress, Typography, alpha } from "@mui/material";
import { COLORS, TYPO } from "../../../styles/uiConstants";

const kg = (v) => `${Number(v).toLocaleString("tr-TR", { maximumFractionDigits: 1 })} kg`;

/** Saf hesap — test edilebilir. */
export function weightProgress(goal, series) {
  const start = Number(goal?.startWeight);
  const target = Number(goal?.targetWeight);
  const sorted = [...(series || [])]
    .filter((p) => Number.isFinite(Number(p.weight)))
    .sort((a, b) => new Date(b.takenAt) - new Date(a.takenAt));
  const current = sorted[0] ? Number(sorted[0].weight) : null;
  if (!(start > 0) || !(target > 0) || start === target) {
    return { start: start || null, target: target || null, current, pct: null, weekly: null, remaining: null };
  }
  const done = current == null ? 0 : (start - current) / (start - target);
  const pct = Math.max(0, Math.min(1, done));
  let weekly = null;
  if (sorted.length >= 2) {
    const latest = sorted[0];
    const cutoff = new Date(latest.takenAt).getTime() - 28 * 864e5;
    const older = sorted.filter((p) => new Date(p.takenAt).getTime() >= cutoff).pop();
    const days = (new Date(latest.takenAt) - new Date(older.takenAt)) / 864e5;
    if (days >= 6) weekly = ((Number(latest.weight) - Number(older.weight)) / days) * 7;
  }
  return {
    start,
    target,
    current,
    pct,
    weekly,
    remaining: current == null ? null : Math.abs(current - target),
  };
}

export default function WeightGoalProgress({ goal, series, palette }) {
  const p = weightProgress(goal, series);
  if (p.pct == null) {
    return (
      <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate500 }}>
        {p.current != null
          ? `Güncel kilo: ${kg(p.current)}. İlerlemeyi görmek için başlangıç ve hedef kilo girin.`
          : "Başlangıç ve hedef kilo girin; ilerleme tartı ölçümlerinden hesaplanır."}
      </Typography>
    );
  }
  const tone = palette?.primary || COLORS.slate700;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, maxWidth: 520 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
        <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate500 }}>Başlangıç {kg(p.start)}</Typography>
        <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate700 }}>
          {p.current != null ? `Güncel ${kg(p.current)}` : "Ölçüm yok"}
        </Typography>
        <Typography sx={{ fontSize: TYPO.label, color: COLORS.slate500 }}>Hedef {kg(p.target)}</Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={Math.round(p.pct * 100)}
        sx={{ height: 4, borderRadius: 2, bgcolor: alpha(tone, 0.12), "& .MuiLinearProgress-bar": { bgcolor: tone } }}
      />
      <Typography sx={{ fontSize: TYPO.caption, color: COLORS.slate500 }}>
        %{Math.round(p.pct * 100)} tamamlandı
        {p.remaining != null ? ` · ${kg(p.remaining)} kaldı` : ""}
        {p.weekly != null
          ? ` · son 4 hafta haftalık ${p.weekly > 0 ? "+" : ""}${p.weekly.toLocaleString("tr-TR", { maximumFractionDigits: 1 })} kg`
          : ""}
      </Typography>
    </Box>
  );
}
